import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { MatConfirmDialogComponent } from 'app/components/mat-confirm-dialog/mat-confirm-dialog.component';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
  
})

export class SharedService {

  private loginUserDetail;
  public loginUserMenu:any = [];
 
  //localStorage.setItem("user", JSON.stringify(result))
  //JSON.parse(localStorage.getItem("user"))
  //Authguard
  public FullTextSearchData:any = []
  
  constructor(private dialog: MatDialog, private http: HttpClient) { }
  openConfirmDialog(msg) {
   return this.dialog.open(MatConfirmDialogComponent, {
      width: '300px',
      panelClass:'confirm-dialog-container',
      disableClose: false,
      data:{
        message:msg
      }
    })
  }
  setUserDetail(data) {
    var competitorArray = []
    var AlertArray = []
    var SiteModules = []
    var AdminModules = []
    //console.log(data.UserMarket)

    sessionStorage.setItem('Firstname', data.Firstname);
    sessionStorage.setItem('LastName', data.LastName);
    sessionStorage.setItem('RoleId', data.RoleId);
    sessionStorage.setItem('Userid', data.Userid);
    sessionStorage.setItem('CompanyId', data.CompanyId);
    sessionStorage.setItem('LastLoginDate', data.LastLoginDate);
    sessionStorage.setItem('LastLogOutDate', data.LastLogOutDate);
    sessionStorage.setItem('CurrentLoginDate', data.CurrentDate);
    sessionStorage.setItem('NotificationDate', data.LastLoginDate);

    sessionStorage.setItem('userMarket', [].toString());
    sessionStorage.setItem('Market', [].toString());
    //debugger;
    if(data.hasOwnProperty('UserMarket') && data.UserMarket.length > 0)
      sessionStorage.setItem('userMarket', JSON.stringify(data.UserMarket));
      sessionStorage.setItem('Market', JSON.stringify(data.UserMarket));

    for (var i = 0; i < data.Competitors.length; i++) {
      if (data.Competitors[i].CompetitorID != undefined || data.Competitors[i].CompetitorID != null) {
        competitorArray.push(data.Competitors[i].CompetitorID)
      }
    }
    sessionStorage.setItem('Competitors', JSON.stringify(data.Competitors));
    sessionStorage.setItem('CompetitorID', JSON.stringify(competitorArray));
    sessionStorage.setItem('XauthToken', data.Token);
    sessionStorage.setItem('IsEmailAlert', data.IsEmailAlert);
    sessionStorage.setItem('AlertMessage', data.AlertMessage);
    try{
      for (var i = 0; i < data.AdminModules.length; i++) {
        if (data.AdminModules[i].path != undefined || data.AdminModules[i].path != null) {
          AdminModules.push({
            path : data.AdminModules[i].path,
            title : data.AdminModules[i].title,
            icon : data.AdminModules[i].icon,
            class : data.AdminModules[i].class,
            allowedRole : data.AdminModules[i].allowedRole
          });
        }
      }
      sessionStorage.setItem('AdminModules', JSON.stringify(AdminModules));  
    }catch(e){}
    try{
      for (var i = 0; i < data.SiteModules.length; i++) {
        if (data.SiteModules[i].path != undefined || data.SiteModules[i].path != null) {
          SiteModules.push({
            path : data.SiteModules[i].path,
            title : data.SiteModules[i].title,
            icon : data.SiteModules[i].icon,
            class : data.SiteModules[i].class,
            allowedRole : data.SiteModules[i].allowedRole,
            isSearch : data.SiteModules[i].isSearch
          });
        }
      }
      sessionStorage.setItem('SiteModules', JSON.stringify(SiteModules));  
    }catch(e){}

    sessionStorage.setItem('CompanyIndustry', data.CompanyIndustry);
    //console.log(JSON.parse((sessionStorage.getItem('SiteModules'))));
    

  }

  getSiteMenu(val)  { 
    switch(val) {
      case 'SiteModules':
        this.loginUserMenu = JSON.parse((sessionStorage.getItem('SiteModules')));
        break;  
      case 'AdminModules':
        this.loginUserMenu = JSON.parse((sessionStorage.getItem('AdminModules')));
        break;
    }
    return this.loginUserMenu;
  }

  removeUserDetail() {
    sessionStorage.removeItem('Firstname');
    sessionStorage.removeItem('LastName');
    sessionStorage.removeItem('RoleId');
    sessionStorage.removeItem('Userid');
    sessionStorage.removeItem('CompanyId');
    sessionStorage.removeItem('Competitors');
    sessionStorage.removeItem('CompetitorID');
    sessionStorage.removeItem('XauthToken');
    sessionStorage.removeItem('LastLoginDate');
    sessionStorage.removeItem('LastLogOutDate');
    sessionStorage.removeItem('CurrentLoginDate');
    sessionStorage.removeItem('NotificationDate');
    sessionStorage.removeItem('IsEmailAlert');
    sessionStorage.removeItem('AlertIndication');
    sessionStorage.removeItem('AlertMessage');
    sessionStorage.removeItem('UserEmailDomain');
    sessionStorage.removeItem('AdminModules');
    sessionStorage.removeItem('SiteModules');
    sessionStorage.removeItem('CompanyIndustry');
  }
  getUserDetail(val) {
    switch (val) {
      case 'Firstname':
        this.loginUserDetail = sessionStorage.getItem('Firstname')
        break;
      case 'LastName':
        this.loginUserDetail = sessionStorage.getItem('LastName')
        break;
      case 'RoleId':
        this.loginUserDetail = sessionStorage.getItem('RoleId')
        break;
      case 'CompanyId':
        this.loginUserDetail = sessionStorage.getItem('CompanyId')
        break;
      case 'Competitors':
        this.loginUserDetail = JSON.parse(sessionStorage.getItem('Competitors'))
        break;
      case 'Userid':
        this.loginUserDetail = sessionStorage.getItem('Userid')
        break;
      case 'XauthToken':
        this.loginUserDetail = sessionStorage.getItem('XauthToken')
        break;
      case 'CompetitorID':
        this.loginUserDetail = JSON.parse(sessionStorage.getItem('CompetitorID'))
        break;
      case 'LastLoginDate':
        this.loginUserDetail = sessionStorage.getItem('LastLoginDate')
        break;
      case 'LastLogOutDate':
        this.loginUserDetail = sessionStorage.getItem('LastLogOutDate')
        break;
      case 'CurrentLoginDate':
        this.loginUserDetail = sessionStorage.getItem('CurrentLoginDate')
        break;
      case 'NotificationDate':
          this.loginUserDetail = sessionStorage.getItem('NotificationDate')
        break;
      case 'IsEmailAlert':
        this.loginUserDetail = sessionStorage.getItem('IsEmailAlert')
        break;
      case 'AlertIndication':
        this.loginUserDetail = JSON.parse(sessionStorage.getItem('AlertIndication'))
        break;
      case 'AlertMessage':
        this.loginUserDetail = sessionStorage.getItem('AlertMessage')
        break;
      case 'UserEmailDomain':
        this.loginUserDetail = sessionStorage.getItem('UserEmailDomain')
        break;
      case 'CompanyIndustry':
        this.loginUserDetail = sessionStorage.getItem('CompanyIndustry')
        break;
    }
    return this.loginUserDetail;
  }

  SetFullTextData(data){
    for (var i = 0; i < data.length; i++) {
      this.FullTextSearchData.push(
        {
          Module : data[i].Module,
          Id : data[i].Id,
          SearchKey : data[i].SearchKey,
          SearchData : data[i].SearchData
        }
      )
    }

    
  }

  RemoveData(){
    for (var i = 0; i < this.FullTextSearchData.length; i++) {
      this.FullTextSearchData.splice(i,1)      
    }
  }

  TrackActivity(data) {
    return this.http.post(environment.apiURL + `user/TrackActivity`, data);
  }

  ConvertDateYYYYMMDD(date){
    //return this.datePipe.transform(date, 'yyyy-MM-dd');
    return new DatePipe('en-US').transform(date, 'yyyy-MM-dd');
  }

  GetIndication(){
    return this.http.get(environment.apiURL+`master/GetIndication`);
  }

  GetCategorization(){
    return this.http.get(environment.apiURL + `master/GetCategorization`);
  }

  GetMasterData(val){
    return this.http.get(environment.apiURL + `master/GetData?Type=`+val);
  }
  SendEmail(data){
    return this.http.post(environment.apiURL + `email/Send`, data);
  }

  EmailDomainValidation(email){
    let isValid: boolean = false;
    var spShareEmailId = email.split("@",2);
    var spUserEmail = this.getUserDetail('UserEmailDomain');
    console.log(spShareEmailId[1])
    console.log(spUserEmail)
    if(spUserEmail == spShareEmailId[1]){
      isValid = true;
    }
    else{
      isValid = false;
    }
    return isValid;
  }

  removeHTML(str){ 
    var tmp = document.createElement("DIV");
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText || "";
  }

}
